module.exports = __webpack_public_path__ + "static/media/n8n.bde2c12f.png";